import React from 'react';
import { IProcessPurchaseOrdersDialog } from './ProcessPurchaseOrdersDialog.properties';
import FormViewModal from 'components/common/Modals/FormViewModal';
import { IActionItem } from 'components/common/Modals/FormViewModal.properties';
import ProcessPurchaseOrdersActionGrid from '../Components/ProcessPurchaseOrdersActionGrid';
import { usePOContextSelector, usePODispatch } from 'components/PurchaseOrders/PurchaseOrders.context';

const ProcessPurchaseOrdersDialog = (props: IProcessPurchaseOrdersDialog) => {
  const { open, onClose, onOk, currentUserId, linesCount, isProcessing } = props;
  const ProcessPurchaseOrderDetails = usePOContextSelector<'ProcessPurchaseOrderDetails'>((state) => state.ProcessPurchaseOrderDetails);
  const contextDispatch = usePODispatch();

  const confirmationActions = (): IActionItem[] => {
    return [
      {
        title: 'Ok',
        isDefault: true,
        disabled: isProcessing,
        listener: () => {
          if (onOk) {
            onOk({
              ...ProcessPurchaseOrderDetails,
            });
          }
        }
      },
      {
        title: 'Cancel',
        listener: () => {
          contextDispatch({ setProcessPurchaseOrderDetails: { Action: null, UserId: null } });
          onClose();
        }
      }
    ];
  };

  function getModalContent(): JSX.Element {

    return <ProcessPurchaseOrdersActionGrid userId={currentUserId} linesCount={linesCount} />;
  }

  return (
    <>
      <FormViewModal
        open={open}
        loading={false}
        title={'Process Purchase Order'}
        dialogActionsButtons={true}
        dialogActionsShadow={false}
        modalContent={getModalContent()}
        actions={confirmationActions()}
      />
    </>
  );
};

export default ProcessPurchaseOrdersDialog;
